import { colors } from '../../Colors/colors'

export const legacyApplicationTheme = {
   light: {
      legacyApplicationList: {
         titleColor: 'text-gray-900',
         descriptionColor: 'text-gray-600',
         filters: {
            defaultBorderColor: 'border-gray-300',
            headerTextColor: 'text-gray-900',
            refreshIconColor: '!bg-base-white',
            closeIconColor: colors['gray-500'],
            filterButtonStyle: 'border-primary-600'
         },
         header: {
            defaultBorderColor: 'border-gray-300',
            headerTextColor: 'text-gray-900',
            refreshIconColor: '!bg-base-white'
         },
         filterConditionPills: {
            borderColor: 'border-gray-300',
            iconColors: colors['primary-600'],
            propertyIconColor: colors['primary-600'],
            tooltipArrowColor: colors['gray-900'],
            addFilterButton: {
               iconColor: colors['primary-600'],
               textColor: 'text-primary-700',
               borderColor: 'border-primary-600'
            },
            clearFilterButton: {
               iconColor: colors['gray-600'],
               textColor: 'text-gray-600'
            }
         },
         table: {
            iconColor: colors['gray-600']
         }
      },
      legacyApplicationDetailedView: {
         header: {
            labelColor: 'text-gray-600',
            valueColor: 'text-gray-800',
            refreshIconColor: colors['gray-700'],
            actionButtonTextColor: 'text-gray-800',
            actionButtonIconColor: colors['gray-700'],
            actionButtonBgColor: '!bg-[#00000010]',
            actionButtonHoverBgColor: 'hover:!bg-[#00000025]'
         },
         tabDetailsExpandableCard: {
            blueMarkerBgColor: 'bg-primary-600',
            bgBaseWhite: 'bg-base-white',
            labelTextColor: 'text-gray-700',
            valueTextColor: 'text-gray-800',
            defaultBorderColor: 'border-gray-300',
            headerTextColor: 'text-gray-700',
            defaultDividerColor: 'bg-gray-300'
         }
      }
   },
   dark: {}
}
